import React, { useContext } from "react";
import { AppContext } from "../Index";
import FamilyGroup from "./FamilyGroup";

const FamilyGroupDetails = () => {
  const appStoreData = useContext(AppContext);
  const { filteredMenuData, setSearchText, searchText } = appStoreData;

  return (
    <div className="col-lg-6 right-cover">
      <div className="search-cover">
        <input
          type="text"
          className="w-100 pl-2 py-2 pr-6 mb-3 form-control search-field"
          placeholder="Search menu item"
          value={searchText}
          onChange={(ev) => setSearchText(ev.target.value)}
        />
      </div>
      <div className="item-list-cover scroll">
        <div className="accordion" id="accordionExample">
          {filteredMenuData.map((fg) => (
            <FamilyGroup familyGroup={fg} key={fg.itemCode} />
          ))}
        </div>
      </div>
      <div className="py-1">
        <small style={{ color: 'black', fontSize: '0.7rem', fontStyle: 'italic' }}>
          (V) Vegetarian (N) Nuts (D) Dairy (G) Gluten (F) Fish (S) Shellfish (SO) Soy (SE) Sesame (E) Egg.

          We cannot guarantee that the products are allergen free or have been produced in an allergen free environment.

          Please inform your server prior to ordering in case of any food allergies.
        </small>
      </div>
    </div>
  );
};

export default FamilyGroupDetails;
